import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { ADMIN, ALWAYZ, COUPANG } from '../../../../common/common.constatns';

import Container from '../../atoms/Container';

interface IProps {
  isLoggedIn: boolean;
  solType: string;
  checkLogout: () => Promise<void>;
}

const HeaderWrap = styled.div`
  background-color: #fff; //배경색상
  width: 100%; //가로 넓이
  height: 80px; // 세로 높이
  border-bottom: 1px solid #ddd; //헤더 밑줄긋기
  position: fixed; //스크롤 내려도 고정되있음(바디 장악하니 주의할것)
  z-index: 999; //position을 주면 z-index 높이가 생긴다.
  top: 0;
`;

const HeaderContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;

  > div:last-child {
    > a,
    span {
      font-weight: 500;
      color: ${({ theme }) => theme.pltoColor};
      padding: 5px 15px;

      &:last-child {
        border: 1px solid ${({ theme }) => theme.pltoColor};
        border-radius: 30px;
      }
    }
  }
`;

function Presenter({ checkLogout, solType, isLoggedIn }: IProps) {
  const { pathname } = useLocation();

  return (
    <>
      {solType !== '' && (
        <HeaderWrap>
          <HeaderContainer noBody={true}>
            <div>
              {
                <Link to={`/${solType.toLowerCase()}/member/create-account`}>
                  <img src="https://cloud.plto.com/design/logo/logo_main.png" alt="main" style={{ width: '8.25rem' }} />
                </Link>
              }
            </div>
            <div>
              {solType !== ADMIN && solType === COUPANG ? (
                !isLoggedIn ? (
                  <>
                    {pathname.includes('/member/create-account') ? (
                      <>
                        <a href={`${process.env.REACT_APP_FRONTEND_ENDPOINT}/guide/wakeup_coupang`} target="_blank" rel="noreferrer">
                          사용 가이드 보러가기
                        </a>
                        <Link to={`/${solType.toLowerCase()}/member/login`}>로그인</Link>
                      </>
                    ) : (
                      <>
                        <a href={`${process.env.REACT_APP_FRONTEND_ENDPOINT}/guide/wakeup_coupang`} target="_blank" rel="noreferrer">
                          사용 가이드 보러가기
                        </a>

                        <Link to={`/${solType.toLowerCase()}/member/create-account`}>회원가입</Link>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {/* <Link to={`/admin/dashboard`}>연동 관리</Link> */}
                    <a href={`${process.env.REACT_APP_FRONTEND_ENDPOINT}/guide/wakeup_coupang`} target="_blank" rel="noreferrer">
                      사용 가이드 보러가기
                    </a>
                    <span onClick={checkLogout} style={{ paddingLeft: 20, cursor: 'pointer' }}>
                      로그아웃
                    </span>
                  </>
                )
              ) : (
                <></>
              )}
              {solType !== ADMIN && solType === ALWAYZ ? (
                !isLoggedIn ? (
                  <>
                    {pathname.includes('/member/create-account') ? (
                      <>
                        <a href={`${process.env.REACT_APP_FRONTEND_ENDPOINT}/guide/wakeup_alwayz`} target="_blank" rel="noreferrer">
                          사용 가이드 보러가기
                        </a>
                        <Link to={`/${solType.toLowerCase()}/member/login`}>로그인</Link>
                      </>
                    ) : (
                      <>
                        <a href={`${process.env.REACT_APP_FRONTEND_ENDPOINT}/guide/wakeup_alwayz`} target="_blank" rel="noreferrer">
                          사용 가이드 보러가기
                        </a>

                        <Link to={`/${solType.toLowerCase()}/member/create-account`}>회원가입</Link>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {/* <Link to={`/admin/dashboard`}>연동 관리</Link> */}
                    <a href={`${process.env.REACT_APP_FRONTEND_ENDPOINT}/guide/wakeup_alwayz`} target="_blank" rel="noreferrer">
                      사용 가이드 보러가기
                    </a>
                    <span onClick={checkLogout} style={{ paddingLeft: 20, cursor: 'pointer' }}>
                      로그아웃
                    </span>
                  </>
                )
              ) : (
                <></>
              )}
              {solType !== ADMIN && solType !== COUPANG && solType !== ALWAYZ ? (
                !isLoggedIn ? (
                  <>
                    <Link to={`/${solType.toLowerCase()}/member/login`}>로그인</Link>
                    <Link to={`/${solType.toLowerCase()}/member/create-account`}>회원가입</Link>
                  </>
                ) : (
                  <>
                    {/* <Link to={`/admin/dashboard`}>연동 관리</Link> */}
                    <span onClick={checkLogout} style={{ paddingLeft: 20, cursor: 'pointer' }}>
                      로그아웃
                    </span>
                  </>
                )
              ) : (
                <></>
              )}
            </div>
          </HeaderContainer>
        </HeaderWrap>
      )}
    </>
  );
}

export default Presenter;
